<template>
  <!-- This component now acts as a bridge to trigger the new WizardServicosPage -->
  <div v-if="false"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { eventBus } from '../../eventBus';
import { log } from '../../utils/DebugLogger';

interface ModalOpenData {
  compromissoId?: number;
  [key: string]: unknown;
}

// Reactive state
const compromissoId = ref<number | null>(null);

// Methods
const open = (id: number): void => {
  log('CheckinWizardModal', 'open', 'Opening new Vue 3 wizard for compromisso', id);
  compromissoId.value = id;
  eventBus.emit('wizard-servicos.open', { compromissoId: id });
};

const handleClose = (): void => {
  log('CheckinWizardModal', 'handleClose', 'Closing wizard');
  compromissoId.value = null;
};

const handleModalOpen = (data: ModalOpenData): void => {
  log('CheckinWizardModal', 'handleModalOpen', 'Standard modal open event received', data);
  if (data?.compromissoId) {
    open(data.compromissoId);
  }
};

// Lifecycle hooks
onMounted(() => {
  log('CheckinWizardModal', 'onMounted', 'Setting up event listeners');
  eventBus.on('modal.checkin-wizard.open', handleModalOpen as (data?: unknown) => void);
});

onBeforeUnmount(() => {
  log('CheckinWizardModal', 'onBeforeUnmount', 'Cleaning up event listeners');
  eventBus.off('modal.checkin-wizard.open', handleModalOpen as (data?: unknown) => void);
});

defineExpose({
  open,
  close: handleClose
});
</script>

<style scoped>
/* No styles needed - bridge component only */
</style>
